import { NavLink } from "react-router-dom";
import { Home, CalendarDays, CheckSquare } from "lucide-react";

const tabs = [
  { to: "/", icon: Home, label: "Dashboard" },
  { to: "/calendar", icon: CalendarDays, label: "Calendar" },
  { to: "/checklists", icon: CheckSquare, label: "Checklists" },
];

export function BottomNav() {
  return (
    <nav className="flex items-stretch bg-white border-t border-stone-200 shrink-0">
      {tabs.map(({ to, icon: Icon, label }) => (
        <NavLink
          key={to}
          to={to}
          end={to === "/"}
          className={({ isActive }) =>
            `flex flex-col items-center justify-center flex-1 gap-1.5 py-3 text-sm font-semibold transition-colors min-h-[72px] ${
              isActive
                ? "text-amber-600 bg-amber-50"
                : "text-stone-400 hover:text-stone-600 active:bg-stone-100"
            }`
          }
        >
          <Icon size={28} strokeWidth={1.5} />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
